import { RoomMessageDto } from '../models/dto/room-message.dto';
import { environment } from '../../config/environments/environment';
import { HttpClient, HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RoomMessage } from '../models/interfaces/room-message.interface';
import { FileResponse } from '../models/dto/file-response';
import { PageDto } from '../models/dto/arrival/page.dto';
import { RoomMessageParamsDto } from '../models/dto/room-message-params.dto';
import { CreateFowardMessage } from '../models/interfaces/create-foward-message';
import { AuthUtil } from '../utils/auth.utils';

@Injectable()
export class RoomsMessagesService {
  private readonly path = 'roomsmessages';
  private readonly pathRoom = 'roomsmessages/room';
  private readonly filesCollection = 'files';
  private readonly download = 'download';

  constructor(
    private readonly http: HttpClient, 
    private readonly authUtil: AuthUtil
  ) { }

  public getAllV2(params?: RoomMessageParamsDto): Observable<PageDto<RoomMessageDto>> {
    const url = `${environment.api.baseUrl}/${this.path}/v2`;

    return this.http.get<PageDto<RoomMessageDto>>(url, {
      params: this.buildHttpParams(params),
    });
  }

  getById(id: string): Observable<RoomMessageDto> {
    return this.http.get<RoomMessageDto>(
      `${environment.api.baseUrl}/${this.path}/${id}`
    );
  }

  getByIdRoom(idRoom: string): Observable<RoomMessageDto[]> {
    return this.http.get<RoomMessageDto[]>(
      `${environment.api.baseUrl}/${this.pathRoom}/${idRoom}`
    );
  }

  downloadFileByIdRoom(
    roomType: string,
    idMsg: string | undefined,
    fileName: string
  ): Observable<FileResponse> {
    const params = `${this.authUtil.getTenant()}/${roomType}/${idMsg}/${fileName}`;
    return this.http.get<FileResponse>(
      `${environment.api.baseUrl}/${this.filesCollection}/${this.download
      }?path=${encodeURIComponent(params)}`
    );
  }

  create(roomMessage: RoomMessage): Observable<RoomMessageDto> {
    return this.http.post<RoomMessageDto>(
      `${environment.api.baseUrl}/${this.path}`,
      JSON.stringify(roomMessage)
    );
  }

  delete(id: string) {
    return this.http.delete(`${environment.api.baseUrl}/${this.path}/${id}`);
  }

  confirmVisualized(id: string): Observable<string> {
    return this.http.patch(
      `${environment.api.baseUrl}/${this.path}/${id}/confirm-visualized`,
      null,
      { responseType: 'text' }
    );
  }

  fowardMessage(forwardMessage: CreateFowardMessage) {
    return this.http.patch<RoomMessageDto>(
      `${environment.api.baseUrl}/${this.path}/foward-message`,
      JSON.stringify(forwardMessage)
    );
  }

  private buildHttpParams(params?: RoomMessageParamsDto): HttpParams {
    let httpParams = new HttpParams()

    if (params?.id && params?.id != '') {
      httpParams = httpParams.set('id', params?.id);
    }

    if (params?.idRoom && params?.idRoom != '') {
      httpParams = httpParams.set('idRoom', params?.idRoom);
    }

    if (params?.page && params?.page > 0) {
      httpParams = httpParams.set('page', params?.page.toString());
    }

    if (params?.limit && params?.limit > 0) {
      httpParams = httpParams.set('limit', params?.limit.toString());
    }

    return httpParams;
  }
}
